import { Entity, field, rootCollection } from 'firebase-firestorm/lib'

@rootCollection({ name: 'accountingExport' })
export class AccountingExport extends Entity {
  @field({ name: 'id' })
  id!: string

  @field({ name: 'restaurantId' })
  restaurantId!: string

  @field({ name: 'createdBy' })
  createdBy!: string

  @field({ name: 'createdAt' })
  createdAt!: Date

  get createdAtDate() {
    if (!( this.createdAt instanceof Date )) {
      // @ts-ignore
      return this.createdAt.toDate()
    }

    return this.createdAt
  }
}
